import {IRouteOnBoardState,IRouteOnBoardActionTypes,IRouteOnBoardActionCreator} from 'models/IRouteBookingState';

const initialState:any = {
    is_api_in_request: false,
    status:null,
    message: ''
}

const reducer = (state = initialState, { type, payload }: IRouteOnBoardActionCreator) => {
    switch (type) {
        case IRouteOnBoardActionTypes.ADD_ROUTE_REQUEST:
            return {
                ...initialState,
                is_api_in_progress: true
            }
        case IRouteOnBoardActionTypes.ADD_ROUTE_SUCCESS:
            return {
                ...state,
                status:200,
                message: 'Added Route successfully'
            }
        case IRouteOnBoardActionTypes.ADD_ROUTE_FAILURE:
            return {
                ...state,
                is_api_in_progress:false,
                ...payload
            } 
        case IRouteOnBoardActionTypes.RESET_ADD_ROUTE_STATE:
            return {
                ...initialState
            }  
        default:
            return state;
    }
};
  
  export default reducer;